// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("./chart2");

var Chartist = require("chartist");
var $ = require("jquery");

function commafy(num) {
  num = num.toString();
  if (!num) return;
  if (num.length >= 4) {
    num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  return num;
}



var data = {
  labels: ["2011", "2012", "2013", "2014", "2015", "2016"],
  series: [{
    name: 'Sheltered',
    data: [4053, 3363, 3381, 3017, 2659, 2576]
  }, {
    name: 'Unsheltered',
    data: [4418, 3824, 2978, 2291, 1950, 1050]
  }]
}
var options = {
  width: '100%',
  height: 200,
  chartPadding: {
    top:0,
    right: 50,
    bottom:0,
    left:0
  },
  reverseData: false,
  horizontalBars: true,
  stackBars: true,

  axisX: {
    showLabel: false
  },
  axisY: {
    showGrid: false
  }
};




var $chart = $('#chart1');

var $toolTip = $chart
  .append('<div class="tooltip"></div>')
  .find('.tooltip')
  .hide();

$chart.on('mouseenter', '.ct-bar', function() {
  var $bar = $(this),
    value = $bar.attr('ct:value'),
    seriesName = $bar.parent().attr('ct:series-name');
  $toolTip.html('<span class="popuptitle">' + seriesName + '</span><br><div class="popuptext">' + (commafy(value)) + '</div>').show();
});

$chart.on('mouseleave', '.ct-bar', function() {
  $toolTip.hide();
});

$chart.on('mousemove', function(e) {
  var bounds = $chart[0].getBoundingClientRect();
  var mouse = {
    left: e.clientX,
    top: e.clientY
  };
  var tWidth = $toolTip.width();
  var position = {
    left: mouse.left - bounds.left - tWidth / 2,
    top: mouse.top - bounds.top - $toolTip.height() - 30
  };
  if (position.left < 0) position.left = 0;
  if (position.left + tWidth > bounds.width) position.left = bounds.width - tWidth;
  position.left += "px";
  position.top += "px";
  $toolTip.css(position);
});

var chart = new Chartist.Bar('#chart1', data, options);

var customLabels = ['8,471', '7,187', '6,359', '5,308', '4,609', '3,626'];


chart.on('draw', function(data) {
  var barEnd, barVerticalCenter, label, value;
  console.log(data.element._node);
  if (data.type === "bar" && data.series.name == "Unsheltered") {
    barEnd = data.x1 + (data.element.width() + 5);
    barVerticalCenter = data.y1 + 6;
    value = data.element.attr('ct:value');
    if (value !== '0') {
      label = new Chartist.Svg('text');
      label.text(customLabels[data.index]);
      label.addClass("ct-barlabel");
      label.attr({
        x: barEnd,
        y: barVerticalCenter,
        'text-anchor': 'right'
      });
      return data.group.append(label);
    }
  }
});
